import { BusEvent } from '@web/common';

export class AdminBoxCreatedBusEvent extends BusEvent {}
